import React from 'react';
import {Button, Col, Row} from 'antd';
import {LeftOutlined} from '@ant-design/icons';

import BookingDetailsHeader from './BookingDetailsHeader';
import CarDetailsHeader from './CarDetailsHeader';
import ErrorBoundary from '../ErrorBoundary';
import {ScreenHeaderProps} from '../../types/carTypes';
import carPlaceholderImage from '../../assets/car-placeholder.png';

import './DetailsScreenHeader.less';

const DetailsScreenHeader = (props : ScreenHeaderProps) => {
    const carImage = props.car?.image ?? carPlaceholderImage;

    return (
        <Row className="header-row">
            <Col xs={2}>
                <Button className="back-button" icon={<LeftOutlined/>} onClick={props.onClickBack}/>
            </Col>
            <Col xs={{span: 20}} md={{span: 14, pull: 1}}>
                <ErrorBoundary>
                    <span className="header-wrapper">
                        <img alt="car" src={carImage} className="header-car-img"/>
                        <span className="description-wrapper">
                            {props.locationID !== undefined ?
                                <BookingDetailsHeader {...props}/>
                                :
                                <CarDetailsHeader {...props}/>
                            }
                        </span>
                    </span>
                </ErrorBoundary>
            </Col>
            {props.children}
        </Row>
    );
}

export default DetailsScreenHeader;
